<template>
  <el-container class="main-layout" direction="vertical">
    <TopHeader />
    <el-container class="layout-body">
      <side-menu />
      <el-container class="content-wrap" direction="vertical">
        <PageTabs />
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>
<script setup>
import SideMenu from "../components/main-box/SideMenu.vue";
import TopHeader from "../components/main-box/TopHeader.vue";
import PageTabs from "../components/main-box/PageTabs.vue";
</script>
<style lang="scss" scoped>
.main-layout {
  height: 100vh;
  overflow: hidden;
}

.layout-body {
  height: calc(100vh - 60px);
  overflow: hidden;
}

.content-wrap {
  min-width: 0;
  background: #f5f7fa;
}

.el-main {
  overflow: auto;
  height: calc(100vh - 100px);
  padding: 15px;
}
</style>
